module.exports = __webpack_public_path__ + "img/35.48ff98d0.jpg";